import styled from 'styled-components';

import card from 'styles/components/card';
import { COLOR_GRAY_60 } from 'styles/variables/colors';

export const Title = styled.h3`
  margin: 0 0 20px 0;
  font-weight: bold;
  font-size: 1.125rem;
`;

export const Card = styled.div`
  ${card}
  padding: 15px 100px 15px 15px;
  display: inline-flex;
  align-items: center;
  padding: 15px;
`;

export const PaymentIcon = styled.div`
  margin-right: 0px;
  float: left;
`;

export const PaymentTitle = styled.h4`
  margin: 0 0 10px 0;
  font-size: 1rem;
`;

export const PaymentSubtext = styled.p`
  margin: 0;
  font-size: 1rem;
  color: ${COLOR_GRAY_60};
`;
